import { SharedFileRequest } from "@wingspanhq/wingspan-api-sdk";
import { WSQueryCache } from "@ws-react-query";

import { queriesSharedFileRequests } from "../../../../../../v3/query/queriesSharedFileRequests";
import { ContextItem, RequirementTableItemData } from "../../../../types";

export const getSharedFileRequestFromCache = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem
): SharedFileRequest | undefined => {
  if (!requirement.dataSourceId) {
    return undefined;
  }

  return WSQueryCache.getQueryData<SharedFileRequest>(
    queriesSharedFileRequests.getSharedFileRequest.getQueryKey({
      sharedFileRequestId: requirement.dataSourceId
    })
  );
};
